import { EProjectSection, trackEventV2 } from '../trackEventV2';
import {
  ESearchEventName,
  IGuidedSearchSelectedInfo,
  IGuidedSearchStepAnsweredInfo,
  IRecommendationTabSelected,
  IRenterSearchedInfo,
  IRenterSearchFilterUpdatedInfo,
  ISearchFilterToggled,
  ISearchNoResultsViewedInfo,
  ISearchResultInfo,
  ISrpRideCrossSellCardClickedInfo,
  ISrpRideCrossSellCardViewedInfo,
  IViewAllRentalsClicked,
} from './types';

export const trackSearchEvent = (event: ISearchResultInfo) => {
  trackEventV2(ESearchEventName.SEARCH_RESULT_VIEWED, EProjectSection.MARKETPLACE, {
    ...event,
    locationQuery: event.locationQuery || null,
    locationLatitude: event.locationLatitude || null,
    locationLongitude: event.locationLongitude || null,
    departureDate: event.departureDate || null,
    returnDate: event.returnDate || null,
    tripDuration: event.tripDuration || null,
    flexibleDateRange: event.filters?.flexible_days || null,
    isSEO: event.isSEO,
    isBlended: event.isBlended,
    searchBlendVariant: event.experiments?.searchBlend || null,
    blendLogic: event.experimentsData?.searchBlend?.blendLogic || null,
    searchLocation: event.locationQuery || null,
  });
};

export const trackRenterSearchedEvent = (event: IRenterSearchedInfo) => {
  return trackEventV2(ESearchEventName.RENTER_SEARCHED, EProjectSection.MARKETPLACE, {
    ...event,
  });
};

export const trackRenterSearchFilterUpdatedEvent = (event: IRenterSearchFilterUpdatedInfo) => {
  trackEventV2(ESearchEventName.SEARCH_FILTER_UPDATED, EProjectSection.MARKETPLACE, {
    ...event,
  });
};

export function trackGuidedSearchSelected(event: IGuidedSearchSelectedInfo) {
  trackEventV2(ESearchEventName.GUIDED_SEARCH_SELECTED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}

// Fires once per answered field when a guest advances past a step or skips from it.
export function trackGuidedSearchStepAnswered(event: IGuidedSearchStepAnsweredInfo) {
  trackEventV2(ESearchEventName.GUIDED_SEARCH_STEP_ANSWERED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}

export function trackRecommendationTabSelected(event: IRecommendationTabSelected) {
  trackEventV2(ESearchEventName.TAB_SELECTED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}

export function trackViewAllRentalsClicked(event: IViewAllRentalsClicked) {
  trackEventV2(ESearchEventName.VIEW_ALL_RENTALS_CLICKED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}

export function trackSearchFilterToggled(event: ISearchFilterToggled) {
  trackEventV2(ESearchEventName.SEARCH_FILTER_TOGGLED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}

export function trackSearchNoResultsViewed(event: ISearchNoResultsViewedInfo) {
  trackEventV2(ESearchEventName.SEARCH_NO_RESULTS_VIEWED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}

export function trackSrpRideCrossSellCardViewed(event: ISrpRideCrossSellCardViewedInfo) {
  trackEventV2(ESearchEventName.SRP_RIDE_CROSS_SELL_CARD_VIEWED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}

export function trackSrpRideCrossSellCardClicked(event: ISrpRideCrossSellCardClickedInfo) {
  trackEventV2(ESearchEventName.SRP_RIDE_CROSS_SELL_CARD_CLICKED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}
